import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useSummaryReducer = () => useSelector((state: ApplicationState) => state.summary);
